import Page from 'components/layout/Page';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import Faqs from '../shared/Faqs';
import { FaqProps } from '../shared/FaqsItem';
import { StyledFaqsWrapper } from './MGMComponent.styled';
import MGMFeatures from './sections/features/MGMFeatures';
import MGMHero from './sections/hero/MGMHero';
import MGMInfo from './sections/info/MGMInfo';
import MGMTrade from './sections/trade/MGMTrade';

const MGMComponent: React.FC = () => {
  const { t } = useI18n('member-get-member');

  const faqs: FaqProps[] = [
    {
      question: t('member-get-member.faqs.faq1.question'),
      active: true,
      answer: (
        <HtmlTrans
          ns={'member-get-member'}
          i18nKey={'member-get-member.faqs.faq1.answer'}
        />
      ),
      renderComponent: true
    },
    {
      question: t('member-get-member.faqs.faq2.question'),
      answer: (
        <HtmlTrans
          ns={'member-get-member'}
          i18nKey={'member-get-member.faqs.faq2.answer'}
        />
      ),
      renderComponent: true
    },
    {
      question: t('member-get-member.faqs.faq3.question'),
      answer: (
        <HtmlTrans
          ns={'member-get-member'}
          i18nKey={'member-get-member.faqs.faq3.answer'}
        />
      ),
      renderComponent: true
    },
    {
      question: t('member-get-member.faqs.faq4.question'),
      answer: (
        <HtmlTrans
          ns={'member-get-member'}
          i18nKey={'member-get-member.faqs.faq4.answer'}
        />
      ),
      renderComponent: true
    }
  ];
  return (
    <Page pageVariant="light" hasScrollTop>
      <div>
        <MGMHero />
        <MGMFeatures />
        <MGMTrade />
        <MGMInfo />
        <StyledFaqsWrapper>
          <Faqs
            faqs={faqs}
            title={t('member-get-member.faqs.title')}
            desc={
              <Trans
                ns={'member-get-member'}
                i18nKey={'member-get-member.faqs.desc'}
                components={{
                  mail: <a href="mailto:team@getmanfred.com"></a>
                }}
              ></Trans>
            }
          />
        </StyledFaqsWrapper>
      </div>
    </Page>
  );
};

export default MGMComponent;
